import { Intersection, Object3D, Raycaster, Vector3 } from "three";
import { IInputEventHandler } from "../utils/input-handler/interface";

export enum MeasurementType {
  TWO_POINT = "2-point",
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal",
  SURFACE = "surface",
  VOLUME_CALCULATION = "volume-calculation",
  FLAT_AREA_CALCULATION = "flat-area-calculation",
  MULTIPLE_POINT = "multiple-point",
}

export enum MeasurementMode {
  CREATE = "create",
  EDIT = "edit",
  INACTIVE = "inactive",
}

export interface ICreateMeasurementParams {
  type: MeasurementType;
}

export interface ICreateVolumeMeasurementParams
  extends ICreateMeasurementParams {
  lowerBound: {
    minColor: number;
    maxColor: number;
  };
  upperBound: {
    minColor: number;
    maxColor: number;
  };
}

export type TCreateMeasurementParams =
  | ICreateMeasurementParams
  | ICreateVolumeMeasurementParams;

export interface IEditMeasurementParams {
  direction?: "xy" | "z" | "default";
  dataflow?: "stream" | "latest_val_on_release";
}

export interface IMeasurement {
  id: number;
  type: MeasurementType;
  _points: Vector3[];
  value: number | any;
  visible?: boolean;
  updateAt?: string;
}

export interface IMeasurementPreviewCreation extends IInputEventHandler {
  points: Vector3[];
  startMeasurement(): Promise<Vector3[]>;
  finishMeasurement(status?: boolean, message?: string): void;
  dispose(): void;
  id: number;
  setPoints(points: Vector3[]): void;
  reset?(): void;
  unmark?(): void;
}

export interface IMeasurementEditOnPositionUpdateObserver {
  onPositionUpdate(id: number, position: Vector3, value?: any): void;
}

export interface IMeasurementEditOnUpdateCompleteObserver {
  onUpdateComplete(id: number, position: Vector3, value?: any): void;
}

export type TMeasurementEditObserver =
  | IMeasurementEditOnPositionUpdateObserver
  | IMeasurementEditOnUpdateCompleteObserver;

export interface IMeasurementVisibleParams {
  text?: boolean;
  measurement?: boolean;
}
export type MeasurementState = "default" | "hovered" | "selected";
export type AutoAttenuableState = "default" | "hovered" | "selected";
export interface IMeasurementHandler
  extends IMeasurement,
    IMeasurementEditOnPositionUpdateObserver,
    IMeasurementEditOnUpdateCompleteObserver {
  setPoints(points: Vector3[]): void;
  dispose(): void;
  setVisibility(params: IMeasurementVisibleParams): void;
  getVisibility(): boolean;
  getPickableObjects(): Object3D[];
  switchMode(mode: MeasurementMode): void;
  appearanceState: MeasurementState;
  changeAppearanceState: (state: MeasurementState) => void;

  hitText(ray: Raycaster): Intersection[];
}
